const CatalogContainersConstants = {
        VEHICLE_DETAILS_CONTAINER_ID: 'vehicle-details-container',
        CONFIGURATOR_CONTAINER_ID: 'configurator',
        VEHICLE_CONFIGURATOR_CONTAINER_ID: 'vehicle-configurator',
        REGO_LOOKUP_CONFIGURATOR_CONTAINER_ID: 'rego-lookup-configurator',
    }
;

export default CatalogContainersConstants;